import React from 'react';
import image1 from '../../../../../images/modules/module-2/1.png';
import image2 from '../../../../../images/modules/module-2/2.png';
import image3 from '../../../../../images/modules/module-2/3.png';
import image4 from '../../../../../images/modules/module-2/4.png';
import image5 from '../../../../../images/modules/module-2/5.png';
import { generateRandomDate } from '../../../utils';
import { NewsCard } from '../NewsCard';
import './index.scss';

export const TopNewsContent = () => {
    return (
        <div className='runup-top-news-wrapper'>
            <div className='runup-top-news'>
                <div className='runup-top-news__big'>
                    <NewsCard
                        type='big'
                        src={image1}
                        text='The Ultimate Trail Shoes That Conquer Every Terrain'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-top-news__right'>
                    <div className='runup-top-news__small runup-top-news__small_1'>
                        <NewsCard src={image2} text='Your Marathon Training Diet' date={generateRandomDate()} />
                    </div>
                    <div className='runup-top-news__small runup-top-news__small_2'>
                        <NewsCard
                            type='revert'
                            src={image3}
                            text='How to Choose the Perfect Recovery Shoe'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-top-news__small runup-top-news__small_3'>
                        <NewsCard
                            src={image4}
                            text='What I Learned from Switching to Run-Walk Intervals'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-top-news__small runup-top-news__small_4'>
                        <NewsCard
                            type='revert'
                            src={image5}
                            text='George Etzweiler, Legendary Runner, Passes at 105'
                            date={generateRandomDate()}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
